import {navigation, rootStore} from '@/store/types'
import {Module} from 'vuex'
import {mutations} from './mutations'
import {getters} from './getters'

const state: navigation = {
    points: [],
    initialization: false,
    currentIndex: 0,
    targetRoute: 'string',
    prevRoute: 'string',
};

export const navigationState: Module<navigation, rootStore> = {
    state,
    mutations,
    getters,
    namespaced: true
};